import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl } from "../config";
import { TextField } from "@mui/material";
import { Error, Button, Label } from "./styles";
import TimelineFilterBuilder, { makeDefaultFilters } from "./TimelineFilterBuilder";

const CreateTimeline = () => {
  const { timelineId } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [filters, setFilters] = useState(makeDefaultFilters());
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!timelineId) return;
    axios
      .get(`${baseUrl}/timelines/${timelineId}`, { withCredentials: true })
      .then((res) => {
        const tl = res.data.data;
        setName(tl.name);
        setDescription(tl.description || "");
        try {
          const f =
            typeof tl.filters === "string" ? JSON.parse(tl.filters) : tl.filters;
          setFilters(f && f.operator ? f : makeDefaultFilters());
        } catch {
          setFilters(makeDefaultFilters());
        }
      })
      .catch(() => setError("Impossible de charger la frise pour édition."));
  }, [timelineId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!name.trim()) {
      setError("Le nom est requis.");
      return;
    }

    const payload = {
      name: name.trim(),
      description,
      filters,
      includeEvents: [],
      excludeEvents: [],
      includePeriods: [],
      excludePeriods: [],
    };

    try {
      if (timelineId) {
        await axios.put(`${baseUrl}/timelines/${timelineId}`, payload, {
          withCredentials: true,
        });
        setMessage("Frise modifiée avec succès !");
      } else {
        const res = await axios.post(`${baseUrl}/timelines`, payload, {
          withCredentials: true,
        });
        setMessage("Frise créée avec succès !");
        if (res.data.id) {
          setTimeout(() => navigate(`/timelines/${res.data.id}`), 800);
        }
      }
    } catch (err) {
      if (err.response?.status === 400) {
        setError(err.response.data?.error || "Veuillez remplir tous les champs requis.");
      } else if (err.response?.status === 401) {
        setError("Vous devez être connecté.");
      } else {
        setError("Erreur lors de l'enregistrement.");
      }
    }
  };

  return (
    <Container>
      <h1>{timelineId ? "Modifier la frise" : "Créer une frise"}</h1>
      <Form onSubmit={handleSubmit}>
        <TextField
          label="Nom de la frise"
          required
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
        <Label>Description :</Label>
        <TextField
          value={description}
          multiline
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          placeholder="Décrivez votre frise ici"
          fullWidth
        />

        <TimelineFilterBuilder filters={filters} onChange={setFilters} />

        <Button
          type="submit"
          style={{
            alignSelf: "center",
            width: "min(100%, 240px)",
            justifyContent: "center",
          }}
        >
          {timelineId ? "Enregistrer les modifications" : "Créer la frise"}
        </Button>
        {message && <Success>{message}</Success>}
        {error && <Error>{error}</Error>}
      </Form>
    </Container>
  );
};

export default CreateTimeline;

const Container = styled.div`
  width: min(1200px, 100%);
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const Success = styled.div`
  color: green;
  margin-top: 10px;
`;
